import React from 'react'
import PropTypes from 'prop-types'
import get from 'lodash/get'
import { Columns, LocalizedText, WinkingChip } from 'labguard-cdk'
import styles from './AlarmTypeCell.scss'

const AlarmTypeCell = ({ alarm }) => (
  <LocalizedText id={alarm.type.i18n}>
    {label => (
      <Columns className={styles.container} align="center" justify="center" layout="auto 1" title={label}>
        <WinkingChip wink={alarm.toBeAcknowledged} size="sm" color={get(alarm, 'type.color', 'secondary')} />
        <span className={styles.label}>{label}</span>
      </Columns>
    )}
  </LocalizedText>
)

AlarmTypeCell.propTypes = {
  alarm: PropTypes.shape({
    type: PropTypes.shape({
      criticality: PropTypes.string.isRequired,
      i18n: PropTypes.string.isRequired,
    }).isRequired,
    toBeAcknowledged: PropTypes.bool,
  }).isRequired,
}

export default AlarmTypeCell
